import Donut from "./Donut.jsx";

export default Donut;



// WEBPACK FOOTER //
// ./src/components/d3Components/donut/index.js